/*
 * Public API Surface of verify
 */

export * from './lib/verify.service';
export * from './lib/verify.component';
export * from './lib/verify.module';
